import { IAlterarInativoAtivoFuncionariosUseCase } from "../../../presentation/useCases/update/alterar_inativo_ativo_funcionario_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// AlterarInativaAtivarFuncionariosUseCase


export class AlterarInativaAtivarFuncionariosUseCase implements IAlterarInativoAtivoFuncionariosUseCase
 {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async alterarInativoAtivoFuncionarios(
    Ativo: number,
    DataTermino: Date | null,
    funcionarios: number[]
  ): Promise<void> {
    
    await this.repository.alterarInativoAtivoFuncionarios(
    Ativo, DataTermino, funcionarios
    );
  }
}
